// Bundle URL resolution.
//
// The viewer accepts ?bundle=<url> with two shapes:
//   - Full URL:   https://pub-xxx.r2.dev/clients/.../W1/
//   - Path-only:  /output/oil_battery/web/W1/   (dev — vite middleware)
//
// Both get normalized to a trailing-slashed absolute URL so URL math
// (resolving sibling files like ../mesh.glb) works uniformly.

const DEFAULT_BUNDLE = "/output/oil_battery/web/W1/";

export function resolveBundleBase(): string {
  const params = new URLSearchParams(window.location.search);
  const raw = params.get("bundle") ?? DEFAULT_BUNDLE;
  return normalizeBase(raw);
}

export function normalizeBase(raw: string): string {
  const withSlash = raw.endsWith("/") ? raw : raw + "/";
  if (/^https?:\/\//.test(withSlash)) return withSlash;
  return new URL(withSlash, window.location.origin).toString();
}

// Resolve a sibling file relative to the per-pass bundle base.
//
// `mesh.glb` is shared across passes and lives one level up at the
// mission root, so the per-pass bundle base needs `..` resolution.
// Per-pass binaries (face_temp.f32, etc.) live alongside
// client_meta.json — those use `${base}<filename>` directly.
export function resolveBundleFile(base: string, relative: string): string {
  return new URL(relative, base).toString();
}
